import { useEffect } from 'react';
import { useThemeStore } from '../store/themeStore';

// Mobile browser chrome colors (top address bar / bottom nav), kept in sync
// with the app background: gray-50 in light, zinc-950 in dark.
const THEME_COLOR = { dark: '#09090b', light: '#f9fafb' };

function applyThemeColor(isDark: boolean) {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', isDark ? THEME_COLOR.dark : THEME_COLOR.light);
}

function applyTheme(theme: string) {
  const root = document.documentElement;
  let isDark: boolean;
  if (theme === 'dark') {
    isDark = true;
  } else if (theme === 'light') {
    isDark = false;
  } else {
    // system
    isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  root.classList.toggle('dark', isDark);
  applyThemeColor(isDark);
}

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    applyTheme(theme);

    if (theme !== 'system') return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => {
      document.documentElement.classList.toggle('dark', e.matches);
      applyThemeColor(e.matches);
    };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [theme]);
}
